import { render, staticRenderFns } from "./SavedReportsDropdown.vue?vue&type=template&id=0b617f7a"
import script from "./SavedReportsDropdown.vue?vue&type=script&lang=js"
export * from "./SavedReportsDropdown.vue?vue&type=script&lang=js"
import style0 from "./SavedReportsDropdown.vue?vue&type=style&index=0&id=0b617f7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports